import config from "../config"
import { generateSalt } from '../helper/encryptHelper'
import { Duration } from "luxon"
import { provide, ref } from "vue"
import { Observable } from "rxjs"

export const genAndSetSalt = function () {
    let salt = generateSalt()
    localStorage.setItem("rms.salt", salt)
    return salt
}

export default function (autoRenew = true) {
    let firstSalt = genAndSetSalt()
    const timer = ref(null)
    const observable = ref()
    const subscriber = ref()

    observable.value = new Observable(sub => {
        sub.next(firstSalt)
        subscriber.value = sub
    })

    if (autoRenew) {
        let offsetSec = Duration.fromObject({ minutes: 1 })
        let refreshTokenInterval = Duration.fromObject({ minutes: config.tokenExpires }).minus(offsetSec)

        timer.value = setInterval(() => {
            let salt = genAndSetSalt()
            if (subscriber.value) {
                subscriber.value.next(salt)
            }
        }, refreshTokenInterval.toMillis())
    }

    provide("TokenService", {
        onUpdate: () => {
            return observable.value
        }
    })

    return {
        timer
    }
}
